// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-l_fz","catalogByServiceItem__title":"c-l_fA"};